export default __webpack_public_path__ + "static/media/Uluru.d3ddaf54.svg";